import { useStyleGuideContext } from '../../StyleGuideContext';
import { Dropzone } from '../Dropzone';
import { Container, Heading, HeadingContainer, Text } from './styles';

export const EmptyPage = () => {
    const { uploadStyleGuideFiles } = useStyleGuideContext();

    return (
        <Container>
            <HeadingContainer align="center" direction="column" gap={3}>
                <Heading>Upload your Style guide</Heading>
                <Text>
                    Style guide can help you to make your content and translation more <br /> consistent across your
                    platform.
                </Text>
            </HeadingContainer>
            <Dropzone onDrop={uploadStyleGuideFiles} />
        </Container>
    );
};

export default EmptyPage;
